import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { LoadPolicyHolderReferenceDataClientResponse } from '../../@types/LoadPolicyHolderReferenceData'
import { api } from '../../Services/API'
import { useLoadPolicyHolderReferenceDataStore } from '../../Stores/useLoadPolicyHolderReferenceDataStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const request = async () => {
  const response = await api.post<LoadPolicyHolderReferenceDataClientResponse>(
    API_ROUTES.loadPolicyHolderReferenceData,
    {
      entityType: 'individual',
    },
  )

  return response.data
}

export const useLoadPolicyHolderReferenceData = () => {
  const { setPolicyHolderReferenceData } =
    useLoadPolicyHolderReferenceDataStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: () => request(),
    onSuccess: (data) => {
      setPolicyHolderReferenceData(data)
    },
    onError: (error: AxiosError<ErrorHandling[]>) => {
      handleErrorRequest({ error })
    },
  })
}
